module.exports = __webpack_public_path__ + "img/1729128029786-IMG_4651.jpeg.05eb1f85.webp";